import React, { useEffect, useMemo, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  CircularProgress,
  Grid,
  Box,
  Button,
  TextField,
  InputAdornment,
  Card,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  useDeleteStoreMutation,
  useGetStoreListQuery,
  useGetUserInfoOnyQuery,
} from "../../../Api/attoDeskApi";
import { IStore, IUserAdmin } from "../../../Api/Interface/api.interface";
import NewPopUpDepartment from "../Edit/index";
import DeletePopup from "../../../Components/Delete/DeletePopup";
import { useNotifier } from "../../../Core/Notifier";
import useDebounce from "../../../Components/SearchDebonce/useDebounce";
import { CiSearch } from "react-icons/ci";
import { Link, useNavigate } from "react-router-dom";
import { useStyles } from "../../../theme/appStyles";
import DeleteOutlineSharpIcon from "@mui/icons-material/DeleteOutlineSharp";
import EditSharpIcon from "@mui/icons-material/EditSharp";
import Pagination from "../../../Components/Pagination";
import AlertPopUp from "../../../Components/AlertPopUp/AlertPopup";
import DoneIcon from "@mui/icons-material/Done";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import VisibilitySharpIcon from "@mui/icons-material/VisibilitySharp";
import useIsMobile from "../../../Core/hook/useIsMobile";
import dayjs, { Dayjs } from "dayjs";

const Index = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { showErrorMessage, showMessage } = useNotifier();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentSearchQuery, setCurrentSearchQuery] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  const debouncedSearchQuery = useDebounce(searchQuery, 300);
  const isMobileRes = useIsMobile();

  const [selectedCoursing, setSelectedCoursing] = useState<IStore | null>(null);

  const [openDialog, setOpenDialog] = useState(false);
  const [openDeleteCategory, setOpenDeleteCategory] = useState(false);
  const [coursingToDelete, setCoursingToDelete] = useState<IStore | null>(null);
  const [selectedIsActive, setSelectedProductIsActive] = useState<string>("1");

  const [deleteAlert, setDeleteAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");

  const { data, isLoading, isError, refetch } = useGetStoreListQuery({
    searchText: currentSearchQuery,
    isActive: selectedIsActive,
    id: "",
  });

  const { data: userData, isLoading: userIsLoading } = useGetUserInfoOnyQuery({
    searchText: "",
  });

  const userList = useMemo(() => {
    return userData?.data as IUserAdmin[];
  }, [userData?.data]);

  const userMap = useMemo(() => {
    const map = new Map();
    userList?.forEach((category) => {
      map.set(category.id, `${category.user_role_name}`);
    });
    return map;
  }, [userList]);

  useEffect(() => {
    if (debouncedSearchQuery.length >= 4 || debouncedSearchQuery === "") {
      setCurrentSearchQuery(debouncedSearchQuery);
      refetch();
    }
  }, [debouncedSearchQuery]);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleProductIsActive = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const selectedValues = event.target.value;
    setSelectedProductIsActive(selectedValues);
  };

  const handleOpenDialog = (coursing: IStore) => {
    setSelectedCoursing(coursing);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedCoursing(null);
    setOpenDialog(false);
  };

  const handleOpenDeletePopup = (coursing: IStore) => {
    setCoursingToDelete(coursing);
    setOpenDeleteCategory(true);
  };

  const handleCloseDeletePopup = () => {
    setCoursingToDelete(null);
    setOpenDeleteCategory(false);
  };

  const [deleteCategory] = useDeleteStoreMutation();
  const handleDelete = async (id: string) => {
    try {
      const response = await deleteCategory(id).unwrap();
      if (response.status) {
        showMessage(response.message);
        setOpenDeleteCategory(false);
      } else {
        setAlertMessage(response.message);
        setDeleteAlert(true);
      }
    } catch (error) {
      showErrorMessage("Failed to delete the supplier ");
    }
  };

  if (isLoading || userIsLoading)
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );

  const coursings: IStore[] = Array.isArray(data?.data)
    ? (data?.data as IStore[])
    : [];

  const handleAddProductClick = () => {
    navigate("/store/create");
  };

  return (
    <Card className={classes.card}>
      <Grid
        container
        justifyContent={"space-between"}
        spacing={5}
        sx={{ padding: 2 }}
        className={classes.titleGrid}
      >
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xs={12}
          sx={{ display: "flex", justifyContent: "flex-end" }}
        >
          <Grid
            container
            spacing={1}
            justifyContent="flex-end"
            sx={{ display: "flex" }}
          >
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <TextField
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <CiSearch className={classes.searchWidgetIcon} />
                    </InputAdornment>
                  ),
                  classes: {
                    root: classes.formControlList,
                  },
                }}
                fullWidth
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="Supplier Name .."
                className={classes.searchTextField}
                size="small"
              />
            </Grid>
            <Grid item>
              <TextField
                select
                size="small"
                value={selectedIsActive || "1"}
                onChange={handleProductIsActive}
                sx={{ flexGrow: 1, width: "100%" }}
                InputLabelProps={{ shrink: true }}
                InputProps={{
                  classes: {
                    root: classes.formControlListStatus,
                  },
                }}
                className={classes.searchTextField34}
              >
                <MenuItem value={"1"}>Active</MenuItem>
                <MenuItem value={"0"}>In Active</MenuItem>
              </TextField>
            </Grid>

            <Grid item>
              <Link to={`/store/create`} className={classes.iconLinkPropNormal}>
                <Button
                  // variant="contained"
                  className={classes.addNewButton}
                  onClick={handleAddProductClick}
                >
                  Add New
                </Button>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </Grid>

      <Grid>
        <TableContainer>
          <Table className={classes.table}>
            <TableHead className={classes.tableHeaderRow}>
              <TableRow>
                <TableCell className={classes.tablheader}>
                  <strong>Supplier</strong>
                </TableCell>
                {!isMobileRes && (
                  <TableCell className={classes.tablheader}>
                    <strong>Active</strong>
                  </TableCell>
                )}
                {!isMobileRes && (
                  <TableCell
                    className={classes.tablheader}
                    // sx={{ textAlign: "center" }}
                  >
                    <strong>Create By</strong>
                  </TableCell>
                )}
                <TableCell
                  className={classes.tablheader}
                  sx={{ textAlign: "right" }}
                >
                  <strong>Actions</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isError || coursings.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={20} align="center">
                    {isError ? "Error fetching data" : "No data available"}
                  </TableCell>
                </TableRow>
              ) : (
                coursings
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row: IStore, index) => (
                    <TableRow key={row.id} className={classes.tableRowHover}>
                      <TableCell
                        component="th"
                        scope="row"
                        className={classes.tablCell}
                      >
                        <Link
                          to={`/store/view/${row.id}`}
                          className={classes.iconLinkPropNormal}
                        >
                          <Typography className={classes.nameTableList}>
                            {row.storeName}
                          </Typography>
                        </Link>
                      </TableCell>
                      {!isMobileRes && (
                        <TableCell
                          component="th"
                          scope="row"
                          className={classes.tablCell}
                        >
                          {row?.isActive == true ? (
                            <DoneIcon
                              className={classes.activeAvatar}
                              sx={{
                                fontSize: 36,
                                borderRadius: "50%",
                                p: "6px",
                              }}
                            />
                          ) : (
                            <CloseOutlinedIcon
                              className={classes.inactiveAvatar}
                              sx={{
                                fontSize: 36,
                                borderRadius: "50%",
                                p: "6px",
                              }}
                            />
                          )}
                        </TableCell>
                      )}
                      {!isMobileRes && (
                        <TableCell
                          scope="row"
                          className={classes.tablCell}
                          // sx={{ textAlign: "center" }}
                        >
                          <Typography>
                            {userMap.get(row.created_by) || ""}
                          </Typography>
                          <Typography>
                            {dayjs(row.created_at).format(
                              "MMM D, YYYY hh:mm A"
                            )}
                          </Typography>
                        </TableCell>
                      )}
                      <TableCell className={classes.tablCell}>
                        <Grid
                          container
                          spacing={1}
                          sx={{ display: "flex", justifyContent: "flex-end" }}
                        >
                          <Grid item>
                            <Link
                              to={`/store/view/${row.id}`}
                              className={classes.iconLinkPropNormal}
                            >
                              <Button
                                className={classes.viewButtonList}
                                onClick={() =>
                                  navigate(`/store/view/${row.id}`)
                                }
                              >
                                <VisibilitySharpIcon
                                  className={classes.viewListIcon}
                                />
                              </Button>
                            </Link>
                          </Grid>
                          <Grid item>
                            <Button
                              className={classes.editButtonList}
                              onClick={() => handleOpenDialog(row)}
                            >
                              <EditSharpIcon className={classes.editListIcon} />
                            </Button>
                          </Grid>
                          <Grid item>
                            <Button
                              className={classes.deleteButtonList}
                              onClick={() => handleOpenDeletePopup(row)}
                            >
                              <DeleteOutlineSharpIcon
                                className={classes.deleteListIcon}
                              />
                            </Button>
                          </Grid>
                        </Grid>
                      </TableCell>
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
          <Grid
            spacing={5}
            p={"18px"}
            py={4}
            justifyContent={"end"}
            container
            textAlign={"center"}
            alignContent={"center"}
            alignItems={"center"}
          >
            <Grid
              sx={{
                textAlign: "end",
                justifyContent: "flex-end",
                alignItems: "flex-end",
              }}
            >
              <Pagination
                count={coursings.length}
                page={page}
                rowsPerPage={rowsPerPage}
                onPageChange={handleChangePage}
              />
            </Grid>
          </Grid>
        </TableContainer>
        {selectedCoursing && (
          <NewPopUpDepartment
            openModel={openDialog}
            handleCloseDialog={handleCloseDialog}
            data={selectedCoursing}
          />
        )}
        {coursingToDelete && (
          <DeletePopup
            open={openDeleteCategory}
            handleCloseDelete={handleCloseDeletePopup}
            onConfirm={async () => {
              await handleDelete(coursingToDelete.id.toString());
            }}
            title="Delete Supplier"
            content={`Are you sure you want to delete "${coursingToDelete.storeName}"?`}
          />
        )}

        <AlertPopUp
          open={deleteAlert}
          onCloseAlert={setDeleteAlert}
          message={alertMessage}
        />
      </Grid>
    </Card>
  );
};

export default Index;
